module.exports = __webpack_public_path__ + "img/NPFcadZW6a1634106943049.7023390a.jpg";